import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import "./AgentList.css";
import Loader from "./Loader";
import { ReactComponent as LegendACW } from "../Images/LegendACW.svg";
import { ReactComponent as LegendAUX } from "../Images/LegendAUX.svg";

const AgentList = ({
  transferTo,
  setTransferTo,
  isLoading,
  activeAgents,
  selectedAgentIDs,
  setSelectedAgentIDs,
  setSelectedChat,
  setIsTabsShown,
}) => {
  const { selectedAgentID } = useSelector((state) => state.agent);
  const { myInfo } = useSelector((state) => state.auth);
  const chatStorage = JSON.parse(sessionStorage.getItem("chatInternal"));

  const handleNewChat = (agent) => {
    const newChat = {
      id: agent.AgentID,
      agentName: `${agent.FirstName} ${agent.LastName}`,
      time: "",
      messages: [],
      isViewed: true,
    };

    if (chatStorage) {
      const existingChat = chatStorage.find(
        (chat) => chat.id === agent.AgentID
      );

      if (existingChat) {
        setSelectedChat(existingChat);
      } else {
        chatStorage.push(newChat);
        sessionStorage.setItem("chatInternal", JSON.stringify(chatStorage));
        setSelectedChat(newChat);
      }
    } else {
      sessionStorage.setItem("chatInternal", JSON.stringify([newChat]));
      setSelectedChat(newChat);
    }

    setIsTabsShown(false);
  };

  useEffect(() => {
    if (selectedAgentID) {
      handleNewChat(
        filteredActiveAgents.find((agent) => agent.AgentID === selectedAgentID)
      );
    }
  }, [selectedAgentID]);

  // All agents except the current user
  const filteredActiveAgents = activeAgents.filter(
    (agent) => agent.AgentID !== myInfo.user.AgentID
  );

  let icon, color, status;

  const renderOption = (agent, index) => {
    switch (agent.CurrentState) {
      case "BUSY":
        icon = "tabler:alert-square-rounded-filled";
        color = "#FF0000";
        status = "Busy";
        break;

      case "READY":
        icon = "tabler:square-rounded-check";
        color = "#00FF00";
        status = "Ready";
        break;

      case "ACW":
        color = "#f0e76f";
        status = "ACW";
        break;

      case "AUX":
        color = "#EE7314";
        status = "AUX";
        break;

      case "NOT BOUND":
        icon = "tabler:square-rounded-x";
        color = "#727272";
        status = "Not Bound";
        break;

      default:
        break;
    }

    return (
      <div
        className={`agentList_option ${
          transferTo?.AgentID === agent.AgentID && "selected"
        } ${selectedAgentIDs?.includes(agent.AgentID) && "selected"}`}
        key={index}
        onClick={() => {
          // For transfer
          setTransferTo && setTransferTo(agent);

          // For internal chat
          // Broadcast
          if (setSelectedAgentIDs) {
            // If agent already selected, remove it
            selectedAgentIDs?.includes(agent.AgentID)
              ? setSelectedAgentIDs(
                  selectedAgentIDs.filter(
                    (agentID) => agentID !== agent.AgentID
                  )
                )
              : // Else, add to selected agents
                setSelectedAgentIDs([...selectedAgentIDs, agent.AgentID]);
            // Personal
          } else if (setSelectedChat) {
            // const chatStorage = JSON.parse(
            //   sessionStorage.getItem("chatInternal")
            // );

            handleNewChat(agent);
          }
        }}
      >
        {agent.CurrentState === "ACW" ? (
          <LegendACW style={{ color: color }} />
        ) : agent.CurrentState === "AUX" ? (
          <LegendAUX style={{ color: color }} />
        ) : (
          <Icon color={color} height="26" icon={icon} width="26" />
        )}
        <p className="option_agentName">{`${agent.FirstName} ${agent.LastName}`}</p>
        <p className="option_agentStatus">{status}</p>
      </div>
    );
  };

  return (
    <div className="transfer_agentList">
      {isLoading ? (
        <Loader />
      ) : filteredActiveAgents.length ? (
        filteredActiveAgents
          .filter((agent) => agent.AgentID !== myInfo.user.AgentID)
          .map((agent, index) => renderOption(agent, index))
      ) : (
        <div className="agentList_option">
          <p style={{ margin: "auto" }}>No agent found</p>
        </div>
      )}
    </div>
  );
};

export default AgentList;
